var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st1{fill:#015198}\n    ")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 5c.6 0 1 .4 1 1v11.9c0 .6-.5 1.1-1.1 1.1H2.1c-.6 0-1.1-.5-1.1-1.1V6.1C1 5.5 1.5 5 2.1 5H22m0-1H2.1C.9 4 0 5 0 6.1v11.8C0 19 .9 20 2.1 20h19.8c1.2 0 2.1-1 2.1-2.1V6c0-1.1-.9-2-2-2z",
    style: {
      fill: "#d2d2d2"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.6 9.2 6.2 13l-.6-3s-.1-.8-.6-.8H2.5v.1s.7.1 1.5.6l1.3 4.8h1.5l2.3-5.6H7.6zM8.8 14.8h1.4l.9-5.6H9.7zM13.2 10.7s.2-1 2-.2l.2-1.2s-.6-.2-1.4-.2c-.7 0-2.4.5-2.4 1.9s2 1.4 2 2.2c0 .8-1.8.7-2.3.2l-.2 1.2s.8.3 1.5.3 2.5-.2 2.5-2c.1-1.5-1.9-1.2-1.9-2.2zM19.2 9.2H18s-.5.1-.7.6c-.2.5-2.1 5-2.1 5h1.6l.2-.8h1.9l.2.8h1.3l-1.2-5.6zm-1.8 3.6.8-2.1.5 2.1h-1.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card-visa.c89519fce7284164705c0c879402cfd8.svg";
export { ForwardRef as ReactComponent };